import { render, staticRenderFns } from "./ReceivedCard.vue?vue&type=template&id=7dadf477&scoped=true"
import script from "./ReceivedCard.vue?vue&type=script&lang=js"
export * from "./ReceivedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dadf477",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dadf477')) {
      api.createRecord('7dadf477', component.options)
    } else {
      api.reload('7dadf477', component.options)
    }
    module.hot.accept("./ReceivedCard.vue?vue&type=template&id=7dadf477&scoped=true", function () {
      api.rerender('7dadf477', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/cardHandling/components/ReceivedCard.vue"
export default component.exports